interface labelType {
	colorType: number;
	color: string;
	icon: string;
	source: {
		small: string;
		normal: string;
	};
}

const labelTypes: Array<labelType> = [
	{
		colorType: 0,
		color: '#F44336',
		icon: 'mdi-cards-heart',
		source: {
			small: '/img/labelPatterns/patterns-01.svg',
			normal: '/img/labelPatterns/patterns-02.svg'
		}
	},
	{
		colorType: 1,
		color: '#E91E63',
		icon: 'mdi-cards-club',
		source: {
			small: '/img/labelPatterns/patterns-03.svg',
			normal: '/img/labelPatterns/patterns-04.svg'
		}
	},
	{
		colorType: 2,
		color: '#9C27B0',
		icon: 'mdi-cards-diamond',
		source: {
			small: '/img/labelPatterns/patterns-05.svg',
			normal: '/img/labelPatterns/patterns-06.svg'
		}
	},
	{
		colorType: 3,
		color: '#3F51B5',
		icon: 'mdi-cards-spade',
		source: {
			small: '/img/labelPatterns/patterns-07.svg',
			normal: '/img/labelPatterns/patterns-08.svg'
		}
	},
	{
		colorType: 4,
		color: '#2196F3',
		icon: 'mdi-anchor',
		source: {
			small: '/img/labelPatterns/patterns-09.svg',
			normal: '/img/labelPatterns/patterns-10.svg'
		}
	},
	{
		colorType: 5,
		color: '#00BCD4',
		icon: 'mdi-bird',
		source: {
			small: '/img/labelPatterns/patterns-11.svg',
			normal: '/img/labelPatterns/patterns-12.svg'
		}
	},
	{
		colorType: 6,
		color: '#009688',
		icon: 'mdi-cactus',
		source: {
			small: '/img/labelPatterns/patterns-13.svg',
			normal: '/img/labelPatterns/patterns-14.svg'
		}
	},
	{
		colorType: 7,
		color: '#4CAF50',
		icon: 'mdi-palm-tree',
		source: {
			small: '/img/labelPatterns/patterns-15.svg',
			normal: '/img/labelPatterns/patterns-16.svg'
		}
	},
	{
		colorType: 8,
		color: '#FFEB3B',
		icon: 'mdi-barley',
		source: {
			small: '/img/labelPatterns/patterns-17.svg',
			normal: '/img/labelPatterns/patterns-18.svg'
		}
	},
	{
		colorType: 9,
		color: '#FF9800',
		icon: 'mdi-bee',
		source: {
			small: '/img/labelPatterns/patterns-19.svg',
			normal: '/img/labelPatterns/patterns-20.svg'
		}
	}
];

export default labelTypes;
